// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1shd7","comment":"styles_comment__11Qys"};